module.exports = __webpack_public_path__ + "img/close-icon.050c3af7.svg";